import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiShield, FiZap, FiCheckCircle } = FiIcons;

const CashOfferForm = () => {
  // Using the iframe method to prevent the "Full Window" expansion bug on desktop.
  const jotFormUrl = "https://form.jotform.com/260036480558054";

  return (
    <section id="get-offer" className="py-20 bg-gray-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          
          {/* Left Side: Conversion Messaging */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center space-x-2 bg-red-600/20 text-red-400 px-4 py-2 rounded-full text-sm font-bold mb-6 border border-red-600/30">
              <SafeIcon icon={FiZap} className="w-4 h-4" />
              <span>Get Your Offer in 24 Hours</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Tell Tyler About <span className="text-red-600">Your Property</span>
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Fill out the simple form to the right. It takes less than 2 minutes, and Tyler will personally review your information to provide the highest possible cash offer.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="bg-red-600/10 p-2 rounded-lg mt-1">
                  <SafeIcon icon={FiShield} className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">100% Free & No-Obligation</h4>
                  <p className="text-gray-400">Receiving an offer costs you nothing and you are under no obligation to accept.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-red-600/10 p-2 rounded-lg mt-1">
                  <SafeIcon icon={FiLock} className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">Privacy Guaranteed</h4>
                  <p className="text-gray-400">Your information is strictly confidential and will never be shared or sold.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-red-600/10 p-2 rounded-lg mt-1">
                  <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">Direct Buyer</h4>
                  <p className="text-gray-400">You're dealing directly with Tyler, not a call center or a listing agent.</p>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 bg-gray-800 rounded-xl border border-gray-700 italic text-gray-400 relative">
               <span className="absolute -top-4 left-6 text-4xl text-red-600 font-serif">"</span>
               I'll look at your house today and give you a fair price. No low-balling, no games. Just a fast, honest sale.
               <div className="mt-4 font-bold text-white not-italic">— Tyler, Owner</div>
            </div>
          </motion.div>

          {/* Right Side: The Form */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl overflow-hidden shadow-2xl relative"
          >
            <div className="bg-red-600 text-white p-6 text-center">
              <h3 className="text-2xl font-bold uppercase tracking-tight">Click "START" to Begin</h3>
              <p className="text-red-100 text-sm mt-1">Get your highest cash offer today</p>
            </div>
            
            <div className="w-full h-[650px] bg-white relative">
              <iframe
                id="jotform-iframe"
                title="Property Information Form"
                src={jotFormUrl}
                style={{ width: '100%', height: '100%', border: 'none' }}
                scrolling="no"
                onMouseEnter={(e) => e.currentTarget.focus()}
              />
            </div>

            <div className="p-4 bg-gray-50 flex justify-center items-center space-x-2 text-gray-500 text-xs uppercase tracking-widest font-bold">
              <SafeIcon icon={FiLock} className="w-3 h-3" />
              <span>Secure Submission & Encrypted Data</span>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default CashOfferForm;